import type { MessageDescriptor } from '@lingui/core'
import { msg } from '@lingui/core/macro'
import {
  DropdownOption,
  ExternalUserFieldAccess,
  FormField,
  GeckoCaseData,
  getStringFieldByDataKey,
  InputType,
} from 'types'
import { requiredStringSchema } from 'utils/zodHelpers'

/**
 * Form fields for creating a new case.
 * Note: content and supplementary_links are handled separately in the creation modal:
 * - content: via RichTextEditor
 * - supplementary_links: auto-extracted from rich text slash commands
 */
export const CreateCaseFormFields = (
  caseTypeOptions: DropdownOption[],
  caseStatusOptions: DropdownOption[],
  translate: (descriptor: MessageDescriptor) => string
): FormField[] => {
  return [
    {
      dataKey: 'case_title',
      label: translate(msg`Case Title`),
      value: '',
      unit_magnitude: null,
      validationRule: requiredStringSchema,
      externalUserAccess: ExternalUserFieldAccess.ReadWrite,
      isNeededForDerivedLayer: false,
      inputType: InputType.Text,
    },
    {
      dataKey: 'case_type',
      label: translate(msg`Case Type`),
      value: '',
      unit_magnitude: null,
      validationRule: requiredStringSchema,
      externalUserAccess: ExternalUserFieldAccess.ReadWrite,
      isNeededForDerivedLayer: false,
      inputType: InputType.Dropdown,
      options: caseTypeOptions,
    },
    {
      dataKey: 'case_status',
      label: translate(msg`Case Status`),
      value: '',
      unit_magnitude: null,
      validationRule: requiredStringSchema,
      externalUserAccess: ExternalUserFieldAccess.ReadWrite,
      isNeededForDerivedLayer: false,
      inputType: InputType.Dropdown,
      options: caseStatusOptions,
    },
  ]
}

export const CaseJSONFromFormFields = (
  formFields: FormField[]
): {
  case_title: string
  case_type: GeckoCaseData['case_type'] | undefined
  case_status: GeckoCaseData['case_status'] | undefined
} => {
  return {
    case_title: getStringFieldByDataKey(formFields, 'case_title') ?? '',
    case_type: getStringFieldByDataKey(formFields, 'case_type') as
      | GeckoCaseData['case_type']
      | undefined,
    case_status: getStringFieldByDataKey(formFields, 'case_status') as
      | GeckoCaseData['case_status']
      | undefined,
  }
}
